import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import logo from "../../assets/logo.png";
import { verifyLogin2FA } from "../../service/Authservice";
import { requestNotificationPermission } from "../../service/firebaseNotification";
import { useAuth } from "../../context/AuthContext";
import "./login.css";

const readPendingLogin = () => {
  try {
    return JSON.parse(sessionStorage.getItem("pendingAdmin2FA"));
  } catch {
    return null;
  }
};

const TwoFactorVerify = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const pending = readPendingLogin();
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (!pending?.tempToken) return <Navigate to="/" replace />;

  const handleVerify = async (event) => {
    event.preventDefault();
    if (!/^\d{6}$/.test(code)) {
      setError("Enter the 6-digit code from your authenticator app.");
      return;
    }

    setLoading(true);
    try {
      const response = await verifyLogin2FA({
        code,
        tempToken: pending.tempToken,
      });
      const admin = response.data.data;

      if (!admin.token) {
        throw new Error(
          "Authentication token was not returned after verification.",
        );
      }

      login(admin);
      sessionStorage.removeItem("pendingAdmin2FA");
      await requestNotificationPermission();
      navigate("/Dashboard", { replace: true });
    } catch (err) {
      setError(err?.message || "Invalid or expired authentication code.");
      setCode("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <div className="Auth-logo">
        <img src={logo} className="logo_img" alt="Wally Market" />
      </div>
      <div className="Auth-form-container1">
        <div className="Auth-form1">
          <div className="Auth-form-content1">
            <h3 className="Auth-form-title">Two-Factor Authentication</h3>
            <p>
              Enter the code from your authenticator app to finish signing in.
            </p>
            <form onSubmit={handleVerify} className="Auth_formdata">
              <label className="Auth_label" htmlFor="two-factor-code">
                Authentication code
              </label>
              <input
                id="two-factor-code"
                className="Auth_input"
                inputMode="numeric"
                autoComplete="one-time-code"
                maxLength={6}
                value={code}
                onChange={(event) =>
                  setCode(event.target.value.replace(/\D/g, "").slice(0, 6))
                }
                placeholder="000000"
                autoFocus
              />
              <button
                type="submit"
                className="Auth_button"
                disabled={loading || code.length !== 6}
              >
                {loading ? "Verifying..." : "Verify & Sign In"}
              </button>
              <button
                type="button"
                className="two_factor_cancel"
                onClick={() => {
                  sessionStorage.removeItem("pendingAdmin2FA");
                  navigate("/");
                }}
              >
                Back to login
              </button>
            </form>
          </div>
        </div>
      </div>
      <Snackbar
        open={Boolean(error)}
        autoHideDuration={5000}
        onClose={() => setError("")}
      >
        <Alert variant="filled" severity="error">
          {error}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default TwoFactorVerify;
